import {Component} from 'react';
import { Button } from 'react-bootstrap';
import "./ForParents/forParents.css";
import "../../css/styles.css";
import { connect } from 'react-redux';
import { setInfo } from '../../redux/actionList';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import RelatedPlayerText from './text/related_player_text';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import Config from '../../config';
import ConfigFile from '../../datasets/config_file';
import {buildUrl} from '../../objects/CommonUse/build_URL';
import AccountSettingsModal from './account_settings_modal';
import InformationModal from '../shared-components/information_modal';
import mergePlayerGamesAndTests from './objects/merge_player_games_and_tests';
import RelatedPlayerReportCard from './related_player_report_card';
import ManagePlayersForAccount from './manage_players_for_account';
import SelectClassModal from './select_class_modal';
import ChangeAccountInformation from './change_account_information';

// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    accountSettings: state.accountSettings,
  
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};


class PlayersAndSettingsDisplay extends Component {
    constructor(props) { 
        super(props);
        this.parentInfo = this.props.parentInfo();
        this.state = {
            headers: setHeadersForFetch(),
            accountLoaded: false,
            userListLoaded: false,
            playerRoleOK: false,
            displayAccountInfo: false,
            playerTestsLoaded: false,
            playerGamesLoaded: false,
            configLoaded: false,
            openHowToPDFDoc: false,
            openSelectClass: false,
            openAccountSettings: false,
            openManagePlayers: false,
            openAccountInformation: false,
            waitState: false,
            newUserAccountList: false,
            subProcess: "relatedPlayersDisplay",
            environment: Config.dataURL.currentEnv,
        }
        this.accountSettingsData = null;
        this.nbrPlayersAllowed = 0;
        this.nbrPlayersWithSignon = 0;
        this.nbrPrimaryAllowed = 0;
        this.nbrPrimaryWithSignon = 0;
        this.userAccount = null;
        this.relatedPlayerArr = [];
        this.userList = [];
        this.accountOwnerArr = [];
        this.accountList = [];
        this.accountNbr = null;
        this.hrefName = "https://assets.playmoneytrain.com/How%20to%20Get%20a%20Class%20Signon.pdf";
        this.buttonText = "";
        this.userName = "";
        this.changeRole = "";
        this.userRole = "";
        this.accountList =[];
        this.newUserAccountList = [];
    }
   
    setShortLongText(){
        let textArr = RelatedPlayerText;
        for (let i=0; i< textArr.length; i++){
            if (textArr[i].type ===  "AccountInfo"){
                 if (this.parentInfo.relatedPlayers.length ===  0){
                    this.accountShortText = textArr[i].shortText0;
                 }else{
                    if (this.parentInfo.relatedPlayers.length ===  1){
                        this.accountShortText = textArr[i].shortText1;
                    }else{
                        this.accountShortText = textArr[i].shortText2;
                    }
                 }
                 this.accountLongText = textArr[i].text;
            }
        }
    }

    determineNbrPlayersRqstd(){
        let rqstdUsersArr = this.parentInfo.accountInfo.rqstdUsersArr;
        this.nbrPrimaryAllowed = 0;
        this.nbrPlayersAllowed = 0;
        for (let i=0; i<rqstdUsersArr.length; i++){
             if (rqstdUsersArr[i].role ===  "player"){
                 this.nbrPlayersAllowed += +rqstdUsersArr[i].nbrUsersRqstd;
             }else{
                 let primaryRole = rqstdUsersArr[i].role;
                 this.primaryRole = primaryRole.charAt(0).toUpperCase() + primaryRole.slice(1);
                 this.nbrPrimaryAllowed += +rqstdUsersArr[i].nbrUsersRqstd;
             }
        }
        
    }
    
    reformatRelatedPlayers(){
        this.reformatRelatedPlayerArr = [];
        this.nbrStarted = 0;
        this.nbrNotStarted = 0;
        if (this.relatedPlayerArr.length ===  0){
            this.playersMessage = "There are currently no players who have sign-on ids for this " +
                this.accountTypeText + "."
        }else{
            const mergedPlayerObj = mergePlayerGamesAndTests(this.relatedPlayerArr, this.playerTests,
                this.playerGames);
            this.reformatRelatedPlayerArr = mergedPlayerObj.returnArr;
            this.nbrStarted = mergedPlayerObj.nbrStarted;
            this.nbrNotStarted = mergedPlayerObj.nbrNotStarted;
            this.playersMessage = "";
        }
    }

    collapseAccountInfoDisplay(){
        this.setState({displayAccountInfo: false});
    }

    expandAccountInfoDisplay(){
        this.setState({displayAccountInfo: true});
    }
  
    openModal(modalName){
        switch (modalName){
            case "selectClass":
                this.setState({openSelectClass: true});
                break;
            case "accountSettings":
                this.accountSettingsData = this.props.accountSettings;
                this.setState({openAccountSettings: true});
                break;
            case "accountInformation":
                this.setState({openAccountInformation: true});
                break;
            case "managePlayers":
                this.changeRole = "player";
                this.setState({openManagePlayers: true});
                break;
            case "manageTeachers":
                this.changeRole = this.userRole;
                this.setState({openManagePlayers: true});             
                break;
            default:
                break;
        }
    }
    
    closeModal(modalName){
        switch (modalName){
            case "selectClass":
                this.setState({openSelectClass: false});
                break;
            case "accountSettings":
                this.setState({openAccountSettings: false});
                break;
            case "accountInformation":
                this.setState({openAccountInformation: false});
                break;
            case "managePlayers":
                this.setState({openManagePlayers: false, openManageLeaders: false});
                break;
            case "closeAll":
                  this.setState({openManagePlayers: false, openAccountSettings: false,
                    openAccountInformation: false });
                break;
            default:
                break;
        }
    }

    changeClassCode(newClassCode){
        this.props.changeClassCode(newClassCode);
        this.closeModal("selectClass");
    }
       
    closeInformationModal(){
        this.setState({openInformationModal: false});
        this.closeModal("closeAll");
    }

    render() {
        if (this.parentInfo.accountLoaded ===  true && this.parentInfo.userListLoaded ===  true){
            this.accountOwnerArr = this.parentInfo.accountInfo.accountOwnerArr;
            this.accountNbr = this.parentInfo.accountInfo.accountNbr;
            this.setShortLongText();
            this.determineNbrPlayersRqstd();
            this.nbrPlayersWithSignon = this.parentInfo.relatedPlayers.length;
            this.nbrPrimaryWithSignon = this.parentInfo.nbrPrimarySignons;
        }
        if (this.parentInfo.configsLoaded ===  true && this.state.playerTestsLoaded === true &&
            this.state.playerGamesLoaded && this.parentInfo.relatedPlayers.length > 0){
            this.reformatRelatedPlayers();
            this.relatedPlayersList = this.reformatRelatedPlayerArr.map((tableRows,index) =>
                <RelatedPlayerReportCard tableInfo={tableRows} key={index}/>
            );
        }

        this.textClass = "mx-3 text-left mt-4";
              
        let role = "";
        if (this.parentInfo.accountInfo.className === "Demonstration Class"){
            role = "Demo";
        }else{
            if (this.userRole){
                const firstChar = this.userRole.substring(0,1).toUpperCase();
                role = firstChar + this.userRole.substring(1, this.userRole.length);
            }
        }
       
    return <>
        <div className="col-8">
        <div className="card mt-3 rounded-corners-lg text-center game-board height-max">
        <button className="pages-back-button ml-4 mt-4" 
            onClick ={()=> this.props.goBack()}>
                    Back
        </button>
        <h3 className="mt-0 text-center">List of Related Players</h3>
        <h3 className="mt-0 text-center text-primary">{this.parentInfo.accountInfo.className}</h3>
        <div className="mt-2 ml-2 ml-4">
            {this.primaryRole === "Teacher"  && this.parentInfo.accountList.length > 1  ?
                <Button variant="primary" className="py-0"
                        onClick={() => this.openModal("selectClass")}>
                            Select A Different Class 
                </Button>
            :
                null
            }
        </div>
        {this.buttonText === "Class" && this.userRole !== "autoPlayer" ?  
            <div className="row">
                <div className="col-5 text-left ml-4">
                    <b>{this.accountTypeText}:&nbsp; </b> {this.accountNbr} 
                </div>
                <div className="col-5 ml-4 text-left">
                        You currently have {this.parentInfo.accountList.length - 1} active classes.
                </div>
            </div>
        :
            null
        }
        
        <div className="row ml-4">
            <div className="col-5 text-left no-wrap">&nbsp;&nbsp;<b>Nbr {this.primaryRole}s for this class: </b>      
                &nbsp;&nbsp;{this.nbrPrimaryWithSignon}</div>
            <div className="col-3 text-left no-wrap"><b>Nbr Players in this {this.groupType}:</b>      
                &nbsp;&nbsp;{this.nbrPlayersWithSignon}</div>
        </div>
        <div className="overflow-scroll mr-3 ml-3 mb-5">
                {this.state.displayAccountInfo ?
                    <span>
                        <div className={this.textClass}>
                            {this.accountShortText}
                            {this.accountLongText}
                            <Button variant="outline-info"  className="p-0" size="sm"
                                onClick={() => this.collapseAccountInfoDisplay()}>
                                Collapse 
                            </Button>
                        </div>
                    </span>
                :
                    <span>
                        <div className={this.textClass}>
                            {this.accountShortText}
                            <Button variant="outline-info" className="p-0" size="sm"
                                onClick={() => this.expandAccountInfoDisplay()}>
                                  Learn More
                            </Button>
                        </div>
                    </span>
                }
                    
                    <div className="mx-3 text-left mt-2">
                        If any of this information does not appear correct to you, please let us know 
                        (click on the 'Contact Us' link that is in the header row of this site).
                    </div>

                    <div className="mx-3 mt-3">
                     
                    </div>
                    {role === "Demo" ?
                        null
                    :
                        <>
                        <h5 className="font-weight-bold text-center mt-4">
                                --------- Update {this.buttonText} Information ----------
                        </h5>
                       <div className="row justify-content-around text-center mt-2 mx-0">
                            <div className="col-3 text-end">
                                <Button variant="primary" className="py-0"
                                    onClick={() => this.openModal("accountSettings")}>
                                    Review/Change Settings
                                </Button>
                            </div>
                            <div className="col-3 text-start">
                               <Button variant="primary" className="py-0"
                                    onClick={() => this.openModal("accountInformation")}>
                                    {this.generalUpdateButtonText}
                                </Button>
                            </div>
                            <div className="col-3 text-end">
                                <Button variant="primary" className="py-0"
                                    onClick={() => this.openModal("managePlayers")}>
                                    Add/Chg Players for {this.buttonText}
                                </Button>
                            </div>
                            <div className="col-3 text-start">
                                <Button variant="primary" className="py-0"
                                    onClick={() => this.openModal("manageTeachers")}>
                                    Add/Chg {role}s for {this.buttonText}
                                </Button>
                            </div>
                        </div>
                    </>
                }
                                    
                <span>
                <div className="mt-4 ml-4">
                    <a className="decorative light-blue-color text-pointer" 
                        href={this.hrefName} target="_blank"
                        rel="noreferrer">
                            View/Print How to Get Player/Student Sign-Ons (PDF)
                    </a>
                </div>

                {this.parentInfo.configsLoaded && this.state.playerTestsLoaded &&
                    this.state.playerGamesLoaded   ?

                    <>
                        {this.parentInfo.relatedPlayers.length > 0  ?
                        <>
                            <h5 className="table-header-background mt-4">Related Players List --- 
                                Number of Players With Active Games {this.nbrStarted}
                            </h5>
                            <table className="table table-no-space mt-2">
                                <tbody className="mt-4">
                                <tr>
                                        <th className="text-center"></th>
                                        <th className="text-center">Player Name</th>
                                        <th className="text-center">Pre-Test<br/> Score</th>
                                        <th className="text-center">Game Status</th>
                                        <th className="text-center">Nbr Games</th>
                                        <th className="text-center">Total Game <br/>Months</th>
                                        <th className="text-center">Post-Test<br/> Score</th>

                                    </tr>
                                    {this.relatedPlayersList}
                                    </tbody>
                            </table>
                            <div>{this.playersMessage}</div>
                            {/*
                            <Button variant="primary"  className="py-0 mr-2" 
                                onClick={() => this.refreshPlayerTestData()}>
                                    Refresh Pre-Test and Post-Test Data
                            </Button>
                            */}
                        </>
                        :
                            <h5 className="mt-4">
                                There are no Players Currently Assigned to this {this.accountTypeText}
                            </h5>
                        }
                    </>
                : 
                    <div>
                        <WaitTimeSpinner />
                    </div>
                }
               
                {this.state.openSelectClass ?
                    <SelectClassModal
                        show={this.state.openSelectClass}
                        accountNbr={this.parentInfo.accountInfo.accountNbr}
                        accountList={this.parentInfo.accountList}
                        onClose={() => this.closeModal("selectClass")}
                        changeClassCode={(newClassCode) => 
                            this.changeClassCode(newClassCode)}
                    />
                :
                    null
                }
                          
                {this.state.openAccountSettings ?
                    <AccountSettingsModal 
                        show={this.state.openAccountSettings}
                        loading={this.props.loadingNewAccount}
                        accountType={this.buttonText}
                        accountNbr={this.parentInfo.accountInfo.accountNbr}
                        accountSettingsData={this.accountSettingsData}
                        onClose={() => this.closeModal("accountSettings")}
                        updateAccountSettings={(accountSettingsObj) => 
                            this.updateAccountSettings(accountSettingsObj)}
                    />
                :
                    null
                }
               
                {this.state.openAccountInformation  ?
                    <ChangeAccountInformation 
                        show={this.state.openAccountInformation}
                        accountType={this.buttonText}
                        accountInfo={this.parentInfo.accountInfo}
                        accountList={this.parentInfo.accountList}
                        onClose={() => this.closeModal("accountInformation")}
                        updateUser={(userObj) => this.updateUser(userObj)}
                        updateAccount={(accountObj, updateType) => this.updateAccount(accountObj, updateType)}
                        processError={(errorObj) => this.props.processError(errorObj)}
                    />
                :
                    null
                }

                {this.state.openManagePlayers  ?
                    <ManagePlayersForAccount 
                        show={this.state.openManagePlayers}
                        accountType={this.buttonText}
                        user={this.userName}
                        role={this.changeRole}
                        userRole={this.userRole}
                        userAccountInfo={this.parentInfo.accountInfo}
                        onClose={() => this.closeModal("managePlayers")}
                        updateUser={(userObj) => this.updateUser(userObj)}
                        updateAccount={(accountObj) => this.updateAccount(accountObj)}
                        processError={(errorObj) => this.props.processError(errorObj)}
                    />
                :
                    null
                }

                {this.state.openInformationModal  ?
                    <InformationModal   
                        time={2000}
                        show={this.state.openInformationModal}
                        infoCode={this.informationCode}
                        onClose={() => this.closeInformationModal()}
                    />
                :
                    null
                }
                          
                </span>
           </div>
        </div>    
       </div>
    </>
    }

    
componentDidMount(){
    this._isMounted = true;
    this.checkForConfigs();
    this.loadPlayerTests();
    if (this.parentInfo.relatedPlayers.length > 0){
        this.loadPlayerGames();
    }else{
        this.setState({playerGamesLoaded: true});
    }
    this.userName = sessionStorage.getItem("username");
    this.userAccount = sessionStorage.getItem("userAccount");
    this.userRole = sessionStorage.getItem("userRole");
    this.className = "";
    this.groupType = "Class";
    if (this.userRole){
        switch (this.userRole){
            case "demo":
            case "teacher":
                this.accountTypeText = "Class Code";
                this.buttonText = "Class";
                this.generalUpdateButtonText = "Create New or Change Class Info";
                break;
            case "parent":
                this.accountTypeText = "Family Code";
                this.groupType = "Household";
                this.buttonText = "Household";
                this.generalUpdateButtonText = "Change Profile Information";
                break;
            case "autoPlayer":
                this.buttonText = "Class";
                break;
            default:
                this.accountTypeText = "";
                break;
        }
    }
    
}

refreshPlayerTestData(){
    this.setState({playerTestsLoaded: false});
    this.loadPlayerTests();
}
    
checkForConfigs()
 {
    let playerArr = (this.parentInfo.relatedPlayers).join(',');
    const funcName = "checkGameConfigs";
    const urlParm = "?userNameArr=" + playerArr;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode ===  200){
                        this.relatedPlayerArr = output.body;
                        this.props.setParentInfo(true, "configsLoaded");
                    }else{
                        const urlObj = {urlParm: urlParm};
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, 
                            errorObject: urlObj};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
    }

       
 loadPlayerTests()
 {
    let playerArr = (this.parentInfo.relatedPlayers).join(',');
    const funcName = "loadFinancialLiteracyTest";
    const urlParm = "?userNameArr=" + playerArr;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode ===  200){
                        this.playerTests = output.body;
                        if (this._isMounted === true){
                            this.setState({playerTestsLoaded: true});
                        }
                    }else{
                        if (statusCode === 250){
                            this.playerTests = [];
                            if (this._isMounted === true){
                                this.setState({playerTestsLoaded: true});
                            }
                        }else{
                            const urlObj = {urlParm: urlParm};
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, 
                                errorObject: urlObj};
                            this.props.processError(errorObj);
                        }
                    }
                });
            };
        });
    }

loadPlayerGames()
{
    let playerList = (this.parentInfo.relatedPlayers).join(',');
    const funcName = "countNbrGames";
    const totalGameMonths = ConfigFile.gameStartItems.totalNbrGameMonths;
    const urlParm = "?totalGameMonths=" + +totalGameMonths + "&playerList=" + playerList;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
        {method:'GET', headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.playerGames = output.body;
                    if (this._isMounted === true){
                        this.setState({playerGamesLoaded: true});
                    }
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
}

updateUser(userObj){
    const funcName = "updateUserAccount";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);

    fetch(uri,
        {
            method: 'PUT', 
            headers: this.state.headers,
            body: JSON.stringify(userObj)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (output.statusCode === 200){ 
                    this.userInfo = output.body;
                    sessionStorage.setItem('defaultUserAccount', this.userInfo.accountNbr);
                    this.informationCode = "UserAccountUpdated";
                    this.setState({openInformationModal: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: this.creditCardObj};
                    this.props.processError(errorObj);
                }
            });
            }
        });
}
    
updateAccount(accountObj, updateType){
    const bodyObj = {
        "accountNbr": accountObj.accountNbr,
        "className": accountObj.className,
        "accountOwner": accountObj.accountOwner,
        "accountOwnerArr": accountObj.accountOwnerArr,
        "rqstdUsersArr": accountObj.rqstdUsersArr,
        "emailAddress": accountObj.emailAddress,
        "gradeLevel": accountObj.gradeLevel
        };
    const funcName = "updateAccount";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
            {method:'PUT', headers: this.state.headers,
            body: JSON.stringify(bodyObj)})
            .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        if (updateType){
                            if (updateType === "accountProfile"){
                                this.props.setParentInfo(output.body, "accountInfo");
                            }
                            this.props.getAccountList();
                            this.informationCode = updateType;
                            this.setState({openInformationModal: true});
                        }
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: bodyObj};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
}


updateAccountSettings(accountSettingsObj) {
    const funcName = "updateAccountSettings";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);

    fetch(uri,
        {
            method: 'PUT', 
            headers: this.state.headers,
            body: JSON.stringify(accountSettingsObj)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (output.statusCode === 200){ 
                    this.accountSettings = output.body;
                    this.props.setInfoRedux(this.accountSettings, "accountSettings");
                    this.informationCode = "AccountSettingsUpdated";
                    this.setState({openInformationModal: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: this.creditCardObj};
                    this.props.processError(errorObj);
                }
            });
            }
        });
    }
}

export default  connect(mapStateToProps, mapDispatchToProps)(PlayersAndSettingsDisplay);